import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
// Cloud React components
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import Tabs, { TabContainer } from 'Components/Tabs';
import EntityTagViewer from 'Modules/.common/components/EntityTagViewer';
import { Pill, Button, Chip } from 'Components';

//actions
import {
    clearRedux,
    alertsOpenAssignedModal,
    deleteAlertSubscriber
} from 'Redux/actions';

const AssignedAlertModal = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const { callBackSuscriber } = props;
    const {
        isOpenModalAssigned: open,
        selectedAlert: alert,
        tab1 = 0,
        tab2 = 0,
        loading
    } = useSelector(state => state.alertsTabRedux);

    const [openConfirm, setOpenConfirm] = useState(false);
    const [subscriberToDelete, setSubscriberToDelete] = useState();
    const [currentTab, setCurrentTab] = useState(tab1);

    useEffect(() => {
        return () => {
            clearRedux("ALERTS_TAB", {
                selectedAlert: {},
                isOpenModalAssigned: false,
                tab1: 0,
                tab2: 0
            });
        }
    }, []);

    const getSubscribers = useCallback((subscribers) => {
        if (!subscribers?.length) return [];

        let subs = [];
        let allContacts = subscribers.find((obj) => obj.contactId === -1);
        let currentDriver = subscribers.find((obj) => obj.contactId === -2);

        if (allContacts) {
            subs.push({ ...allContacts, contact: { id: 1, title: messages['alertsTabView_allContacts'] } });
        } else {
            let newSubscribers = subscribers.filter((item) => item.contactId !== -2)
            subs.push(...newSubscribers);
        }

        if (currentDriver) {
            subs.push({ ...currentDriver, contact: { id: 2, title: messages['alertsTabView_currentDriver'] } });
        }
        return subs;
    });

    const handleClose = useCallback(() => {
        dispatch(alertsOpenAssignedModal(false));
        clearRedux("ALERTS_TAB", {
            selectedAlert: {},
            isOpenModalAssigned: false,
            tab1: 0,
            tab2: 0
        });
    });

    let title = "";
    if (currentTab == 0) {
        title = `${messages['alertsTabView_subscribers']} ${alert?.name ? `(${alert?.name})` : ""}`;
    } else if (currentTab == 2) {
        title = `${messages['alertsTabView_assignedDrivers']} ${alert?.name ? `(${alert?.name})` : ""}`;
    } else {
        title = `${messages['alertsTabView_assignedUnits']} ${alert?.name ? `(${alert?.name})` : ""}`;
    }

    let units = [];
    let drivers = [];
    let tags = [];
    let landmarks = [];
    let allSelected = false;
    const showAssignedDriversTab = alert?.type === "FuelCard";
    const safeTab = showAssignedDriversTab ? tab1 : Math.min(tab1, 1);

    if (alert && alert?.assignedTo?.length) {
        alert?.assignedTo?.forEach(item => {
            if (item?.entity?.name === "Tag") {
                tags.push(item?.entity);
            } else if (item?.entity?.name === "Unit") {
                units.push(item?.entity);
            } else if (item?.entity?.name === "Landmark") {
                landmarks.push(item?.entity);
            } else if (item?.entity?.name === "Driver") {
                drivers.push(item?.entity);
            }

            allSelected = alert?.assignedTo?.find(at => at?.entity?.id == -1) ? true : false;
        });
    }

    return (
        <div>
            <Modal
                title={title}
                open={open}
                loading={loading}
                position="right"
                size="small"
                style={{ overflow: 'hidden' }}
                className="overflow-hidden"
                handleClose={handleClose}
            >
                <ModalBody
                    style={{
                        overflow: 'hidden',
                        marginBottom: 0
                    }}
                >
                    <div
                        style={{
                            padding: "0px 24px 24px 24px",
                            height: "calc(100vh - 125px)"
                        }}
                    >
                        <Tabs
                            tab={safeTab}
                            type="icon-indicator"
                            onChange={(newTab) => {
                                setCurrentTab(newTab);
                            }}
                            border
                        >
                            <TabContainer
                                iconIndicator="person"
                                label={messages['alertsTabView_subscribers']}
                                index={0}
                                style={{ paddingLeft: 0, paddingRight: 0 }}
                            >
                                {
                                    alert?.subscribers?.length > 0 ?
                                        <React.Fragment>
                                            {getSubscribers(alert?.subscribers)?.map((subscriber, index) => {
                                                return (
                                                    <Chip
                                                        key={index}
                                                        label={subscriber.contact?.title || messages['alertsTabView_noname']}
                                                        handleDelete={() => {
                                                            setSubscriberToDelete(subscriber);
                                                            setOpenConfirm(true);
                                                        }}
                                                    />
                                                )
                                            })}

                                        </React.Fragment> :
                                        <span className="no-more-items" style={{ padding: 0 }}>
                                            {messages['alertsTabView_noSubscribersFound']}
                                        </span>
                                }
                            </TabContainer>

                            <TabContainer
                                iconIndicator="directions_car"
                                label={messages['alertsTabView_assignedUnits']}
                                index={1}
                                style={{ paddingLeft: 0, paddingRight: 0 }}
                            >
                                {
                                    allSelected ?
                                        <Pill
                                            textField="label"
                                            item={{ id: -1, label: messages['alertsTabView_all'] }}
                                            outlined={false}
                                            style={{ border: '0', width: '100%' }}
                                            colorField="default"
                                            colorSelection="005bf8"
                                        /> :
                                        <EntityTagViewer
                                            entity="Unit"
                                            selectedEntities={units}
                                            selectedTags={tags}
                                            height="calc(100vh - 362px)"
                                            tab={tab2}
                                        />
                                }

                            </TabContainer>

                            {
                                showAssignedDriversTab &&
                                <TabContainer
                                    iconIndicator="badge"
                                    label={messages['alertsTabView_assignedDrivers']}
                                    index={2}
                                    style={{ paddingLeft: 0, paddingRight: 0 }}
                                >
                                    {
                                        allSelected ?
                                            <Pill
                                                textField="label"
                                                item={{ id: -1, label: messages['alertsTabView_allDriversSelected'] }}
                                                outlined={false}
                                                style={{ border: '0', width: '100%' }}
                                                colorField="default"
                                                colorSelection="005bf8"
                                            /> :
                                            <EntityTagViewer
                                                entity="Driver"
                                                selectedEntities={drivers}
                                                selectedTags={drivers.length > 0 ? tags : []}
                                                height="calc(100vh - 362px)"
                                                tab={tab2}
                                            />
                                    }

                                </TabContainer>
                            }
                        </Tabs>
                    </div>
                </ModalBody>

                <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
                    <Button
                        disabled={false}
                        onClick={handleClose}
                        className="btn-cancel"
                    >
                        {messages['cancel']}
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal
                title=""
                open={openConfirm}
                size="small"
                onClose={() => {
                    setOpenConfirm(!openConfirm);
                }}
            >
                <ModalBody>
                    <p style={{ padding: "12px 24px" }}>
                        {messages['alertsTabView_deleteAlertSubscriberContent']}
                    </p>
                </ModalBody>

                <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
                    <Button
                        disabled={loading}
                        onClick={() => {
                            setOpenConfirm(!openConfirm);
                        }}
                        variant="contained"
                        className="btn-cancel"
                    >
                        {messages['alertsTabView_deleteAlertSubscriberCancel']}
                    </Button>

                    <Button
                        disabled={loading}
                        onClick={() => {
                            dispatch(deleteAlertSubscriber(
                                subscriberToDelete?.id,
                                alert?.id,
                                messages['alertsTabView_successSubscriberDeletion'],
                                messages['alertsTabView_failedSubscriberDeletion'],
                            ));
                            callBackSuscriber();
                            setOpenConfirm(!openConfirm);
                        }}
                        className="btn btn-red"
                    >
                        {messages['alertsTabView_deleteAlertSubscriberDelete']}
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default AssignedAlertModal;